import Vue from 'vue'

export default {
  fetch (tab, calledOnce = false, role) {
    if (role === 'externalAdmin') {
      return Vue.http.get(window.API_URL + 'doctors/specialist_appointment_requests/admin_requests?status=' + tab)
    } else if (role === 'specialistDoctor') {
      return Vue.http.get(window.API_URL + 'doctors/specialist_appointment_requests?status=' + tab)
    } else {
      return Vue.http.get(window.API_URL + 'doctors/appointment_requests/' + tab, {params: {calledOnce}})
    }
  },

  updateRemark (obj) {
    return Vue.http.post(window.API_URL + 'doctors/appointment_requests/update_remark', obj)
  },
  updateStatus (obj) {
    return Vue.http.post(window.API_URL + 'doctors/appointment_requests/update_status', obj)
  },
  selfAssign (object) {
    return Vue.http.get(window.API_URL + 'doctors/appointment_requests/' + object.id + '/' + object.type)
  },
  spcApttSatusChange: function (obj) {
    return Vue.http.put(window.API_URL + 'doctors/specialist_appointment_requests/' + obj.id, obj)
  },
  doctorList: function (obj) {
    return Vue.http.get(window.API_URL + 'doctors/specialist_appointment_requests/' + obj.id + '/doctors_list')
  },
  slotsList: function (obj) {
    return Vue.http.post(window.API_URL + 'doctors/specialist_appointment_requests/slots', obj)
  },
  meeting_link (id) {
    return Vue.http.get(window.API_URL + 'doctors/specialist_appointment_requests/' + id + '/meeting_link')
  }
}



// WEBPACK FOOTER //
// ./src/api/appointments.js